module.exports = __webpack_public_path__ + "FSAlbert-Bold.f4ac77f11e1ffd6519b6.otf";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fsAlbert/FSAlbert-Bold.otf
// module id = ../../../../../src/assets/fonts/fsAlbert/FSAlbert-Bold.otf
// module chunks = main